var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-chat-info",class:{ 'schedule-change': _vm.chatType === 'schedule_change' }},_vm._l((_vm.infos),function(item,i){return _c('div',{key:i,staticClass:"item flex-row"},[_c('div',{staticClass:"dot m-r-4"}),_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(item)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }